<template>
  <div>
    <div v-if="!confirmMsg" class="sm-activate-customer">
      <h4>Activate {{item.full_name}}?</h4>
      <div  v-if="item.scheduled_activation_date" class="sm-activate-customer__scheduler"> 
        <div class="sm-activate-customer__scheduler--head"><include-svg :name="'icon-expl-gray'"/> {{item.full_name}} will be activated on:</div>
        <div @mouseenter="schFocused = 1" @mouseleave="schFocused = null">
        <datepicker-wrap
          v-model="activationDate"
          :label="``"
          :notBefore="new Date() - 24*3600000"
          :val="activationDate"
          :outerVal="activationDate"
          :clearable="false"
          :class="'sm-form__customer-col-label'"
          :higherIndex="schFocused === 1"
          :open="schFocused === 1"
        />
        </div>
        <div class="sm-activate-customer__scheduler--btn">
          <btn-block
            :type="'grey-fill'"
            :text="'Cancel'"
            :classes="['sm-btn--small']"
            @click="cancelScheduled"
          />
        </div>
      </div>
      <div @mouseenter="schFocused = null">
        <dropdown-wrap
          v-model="selectedPlan"
          :val="selectedPlan"
          :options="plans"
          :placeholder="'Select plan...'"
          :label="'Plan'"
          :class="{
            'error': errors.first('plan_id')
          }"
        />
        <span
          v-if="errors.first('plan_id')"
          class="sm-error sm-tiny"
        >{{errors.first('plan_id')}}</span>

        
      </div>
      <div @mouseenter="schFocused = null">
        <dropdown-wrap
          v-if="filteredCoupons.length"
          v-model="selectedCoupon"
          :val="selectedCoupon"
          :options="filteredCoupons"
          :placeholder="'Select coupon...'"
          :label="'Coupon'"    
        />
      </div>
      <div @mouseenter="schFocused = 2" @mouseleave="schFocused = null">
        <datepicker-wrap
          v-if="!item.scheduled_activation_date"
          v-model="activationDate"
          :label="`Activation date`"
          :notBefore="new Date() - 24*3600000"
          :val="activationDate"
          :outerVal="activationDate"
          :clearable="false"
          :class="'sm-form__customer-col-label'"
          :higherIndex="schFocused === 2"
          :open="schFocused === 2"
        />
      </div>
      <div v-show="provider.payment_gateway" @mouseenter="schFocused = 3" @mouseleave="schFocused = null">
        <datepicker-wrap
          v-model="billingStartDate"
          :label="`Billing start date`"
          :notBefore="new Date(activationDate) - 24*3600000"
          :val="billingStartDate"
          :outerVal="billingStartDate"
          :clearable="false"
          :class="'sm-form__customer-col-label'"
          :higherIndex="schFocused === 3"
          :open="schFocused === 3"
        />
      </div>
      <div v-if="provider.payment_gateway">
        <input-text
          :label="'Initial credit'"
          :value="formatPrice(initialCredit)"
          v-validate="`required`"
          data-vv-name="initial_credit"
          data-vv-as="Initial Credit"
          @focus="preProcessInput"
          @blur="e => setAmount(e, initialCredit)"
        />
      </div>
      <div class="sm-activate-customer__switch first" v-if="selectedPlan && selectedPlan.setup_fee">
        <span>Apply setup fee {{formatPrice(selectedPlan.setup_fee)}}</span>
        <label class="sm-switcher">
          <input 
            v-model="chargeSetupFee"
            type="checkbox" 
          />
          <span></span>
        </label>
      </div>
      <div class="sm-activate-customer__switch">
        <span>Send welcome email</span>
        <label class="sm-switcher">
          <input 
            v-model="sendWelcome"
            type="checkbox" 
          />
          <span></span>
        </label>
      </div>
    </div>
    <div v-else class="sm-confirm">
      <h4>Are you sure?</h4>
      <p>{{item.full_name}} will be activated to a yearly plan.</p>
    </div>
    <div class="sm-activate-customer-flex">
      <!-- <btn-block
        :class="'sm-btn--small sm-btn--grey'"
        :text="'Cancel'"
        @click="handleCancelation"
      /> -->
      <btn-block
        :type="'large'"
        :text="'Activate'"
        @click="activateCustomer"
      />
    </div>
  </div>
</template>

<script>
import DropdownWrap from '@/components/DropdownWrap';
import Checkbox from '@/components/Checkboxes';
import InputText from '@/components/InputText.vue';
import {FormatPrice} from '@/utils/general-data';
import DatepickerWrap from '@/components/DatepickerWrap';
import { mapActions, mapGetters } from 'vuex';
import {ProcessInputValue} from '@/utils/input';

export default {
  name: 'activate-customer',
  components: {
    'dropdown-wrap': DropdownWrap,
    'checkbox-block': Checkbox,
    'datepicker-wrap': DatepickerWrap,
    'input-text': InputText,
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    coupons: {
      type: Array,
      default: () => []
    },
    plans: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedPlan: null,
      selectedCoupon: null,
      activationDate: this.$moment().format('YYYY-MM-DD'), 
      billingStartDate: this.$moment().format('YYYY-MM-DD'),
      initialCredit: 0,
      chargeSetupFee: false,
      sendWelcome: false,
      confirmMsg: false,
      schFocused: null, // to fix z-index of popup menus
    }
  },
  computed: {
    ...mapGetters({
      provider: 'provider'
    }),
    filteredCoupons() {
      let arr = this.coupons.filter(item => {
        if (!item.active)
          return false;

        if (item.plan_id && this.selectedPlan && item.plan_id != this.selectedPlan.id)
          return false;

        return true;
      });

      if (!arr.length)
        return [];
      else
        return [
          {
            id: 0,
            name: 'None'
          },
          ...arr.map(item => {
            return {
              id: item.id,
              name: item.code
            }
          })
        ];
    }
  },
  created() {

    this.selectedCoupon = this.filteredCoupons[0];
    this.getCustomer(this.item.id).then(res => {

      const scheduled = res.scheduled_activation_options;

      if(scheduled) {
        this.selectedPlan = this.plans.find(plan => plan.id == scheduled.plan_id && plan.term == scheduled.term);
        this.activationDate = scheduled.scheduled_activation_date;
        this.billingStartDate = scheduled.billing_start_date;
        this.chargeSetupFee = scheduled.apply_setup_fee == 'true' ? true : false;
        this.sendWelcome = scheduled.trigger_welcome_email == 'true' ? true : false;
        this.initialCredit = scheduled.initial_credit ? scheduled.initial_credit : 0;

        if(scheduled.apply_coupon == 'true')
          this.selectedCoupon = this.filteredCoupons.find(c => c.id == scheduled.coupon_id);
        
      } 
    })

    const firstMonthlyPlan = this.plans.find(plan => plan.term === 'monthly');
    this.selectedPlan =  firstMonthlyPlan ? firstMonthlyPlan : this.plans[0];
    
    if (!this.item.full_name)
      this.item.full_name = `${this.item.first_name} ${this.item.last_name}`;
  },
  methods: {
    ...mapActions({
      getCustomer: 'customers/getCustomer'
    }),
    formatPrice: FormatPrice,
    processInputValue: ProcessInputValue,
    activateCustomer() {
      if (!this.selectedPlan || !this.selectedPlan.id) {
        this.errors.add({
          field: 'plan_id',
          msg: 'Please select plan'
        });
        return;
      }

      let toSend = {
        id: this.item.id,
        params: {
          plan_id: this.selectedPlan.id,
          term: this.selectedPlan.term,
          scheduled_activation_date: this.$moment(this.activationDate) > this.$moment() ? this.activationDate : null,
          billing_start_date: this.billingStartDate,
          apply_charge: true, // Always true
          initial_credit: this.initialCredit,
          apply_setup_fee: this.selectedPlan.setup_fee && this.chargeSetupFee,
          trigger_welcome_email: this.sendWelcome,
        }
      };

      if (this.selectedCoupon && this.selectedCoupon.id != 0) {
        toSend.params.apply_coupon = true;
        toSend.params.coupon_id = this.selectedCoupon.id;
      }
      
      if (this.selectedPlan.term === 'yearly' && !this.confirmMsg) {
        this.confirmMsg = true;
      } else {
        this.$emit('activate', toSend);
      }
    },
    cancelScheduled() {
      this.$emit('cancelScheduled', {id: this.item.id});
    },
    handleCancelation() {
      if (this.confirmMsg) {
        this.confirmMsg = false;
      } else {
        this.$emit('cancel')
      }
    },
    preProcessInput(e) {
      e.srcElement.select();
    },
    setAmount(e) {
     this.initialCredit = this.processInputValue(e, 'price');
    }
  }, watch: {
    activationDate(val) {
      if(new Date(val) > new Date(this.billingStartDate))
        this.billingStartDate = val;
    }
  },
}
</script>